import React from 'react'

import Icon, { Props } from './Icon'

const IconPeople: React.FC<Props> = (props) => {
  return (
    <Icon title="" viewBox="0 0 23.269 19.08" {...props}>
      <path d="M6.976 19.08h9.307v-7.911a4.654 4.654 0 10-9.307 0zM6.283 11.169v6.05H3.025v-5.585A3.08 3.08 0 016.05 8.609h.931a4.688 4.688 0 00-.698 2.56zM20.244 17.222h-3.258v-6.05a4.693 4.693 0 00-.7-2.56h.931a3.08 3.08 0 013.025 3.025zM11.635 0a2.689 2.689 0 00-2.793 2.792 2.8 2.8 0 105.585 0A2.688 2.688 0 0011.635 0zM2.094 9.54c.233 0 .466.232.7.232a2.509 2.509 0 00-.465 1.862v4.188H.002v-3.955A2.3 2.3 0 012.094 9.54zM6.049 3.956a1.861 1.861 0 000 3.723 1.874 1.874 0 100-3.723zM23.269 15.822h-2.327v-4.188a2.506 2.506 0 00-.466-1.862c.233 0 .466-.232.7-.232a2.3 2.3 0 012.095 2.327zM17.219 3.956a1.874 1.874 0 100 3.723 1.712 1.712 0 001.861-1.861 1.835 1.835 0 00-1.861-1.862zM2.094 6.282c-.7 0-1.163.465-1.163 1.4a1.1 1.1 0 001.163 1.164 1.3 1.3 0 001.4-1.164 1.341 1.341 0 00-1.4-1.4zM21.174 6.282a1.341 1.341 0 00-1.4 1.4 1.3 1.3 0 001.4 1.164 1.1 1.1 0 001.164-1.164c0-.935-.466-1.4-1.164-1.4z" />
    </Icon>
  )
}

export default IconPeople
